import React from "react"

const SFTPSettingsContext = React.createContext(null)

export default SFTPSettingsContext
